module.exports = new __parcel__URL__("blowfish.8afad7f1.svg").toString();